// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

p {
  font-size: 1rem;
}
@media (min-width: 768px) {
  p {
    font-size: 2rem;
  }
}

h2 {
  font-size: 1.5rem;
}
@media (min-width: 768px) {
  h2 {
    font-size: 3rem;
  }
}

h3 {
  font-size: 1.25rem;
}
@media (min-width: 768px) {
  h3 {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_partials.scss","webpack://./src/components/PuzzleBoard/PuzzleBoard.scss"],"names":[],"mappings":"AAiBA;EACE,sBAAA;AChBF;;AD8BA;EACE,qBAAA;AC3BF;;AD6BA;EACE,eAAA;AC1BF;ADJE;EA6BF;IAGI,eAAA;ECxBF;AACF;;AD0BA;EACE,iBAAA;ACvBF;ADbE;EAmCF;IAGI,eAAA;ECrBF;AACF;;ADuBA;EACE,kBAAA;ACpBF;ADtBE;EAyCF;IAGI,eAAA;EClBF;AACF","sourcesContent":["//Colors\n$square-dark:rgb(181, 136,99);\n$square-light:rgb(240, 217,181);\n$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n@mixin tablet {\n  @media (min-width: $tablet-breakpoint) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media (min-width: $desktop-breakpoint) {\n    @content;\n  }\n}\n\n*{\n  box-sizing: border-box;\n}\n//Margins for these pages are consistent, so they're defined here as variables.\n$mobile-indent: 1rem;\n$tablet-indent: 2.25rem;\n\n//This needs to change based on the width of the window.\n//We get the width with 100vw, find how much larger the window is than our desktop breakpoint,\n//then divide it by 2 so that the indent can be applied to both sides.\n$base-desktop-indent: 25rem;\n$desktop-indent: calc(\n  $base-desktop-indent + ((1vw * 100) - $desktop-breakpoint) / 2\n);\n\na {\n  text-decoration: none;\n}\np{\n  font-size: 1rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}\nh2{\n  font-size: 1.5rem;\n  @include tablet{\n    font-size: 3rem;\n  }\n}\nh3{\n  font-size: 1.25rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}","* {\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none;\n}\n\np {\n  font-size: 1rem;\n}\n@media (min-width: 768px) {\n  p {\n    font-size: 2rem;\n  }\n}\n\nh2 {\n  font-size: 1.5rem;\n}\n@media (min-width: 768px) {\n  h2 {\n    font-size: 3rem;\n  }\n}\n\nh3 {\n  font-size: 1.25rem;\n}\n@media (min-width: 768px) {\n  h3 {\n    font-size: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
